import React, { useEffect } from 'react'
import { shape, string, func, number } from 'prop-types'

import useUtm from '@hooks/useUtm'
import useLoading from '@hooks/useLoading'
import useContact from '@hooks/useContact'
import { useHistory } from 'react-router-dom'
import useRouteBuilder from '@hooks/useRouteBuilder'

import mapFormToBroker from '@client/mapper/brokerMapper'

import Footer from '@components/NewFooter'

import shouldAddBrokerFakeEmail from '@client/utils/brokerEmail'

import useInternationalization from '@hooks/useInternationalization'
import * as Sections from './sections'

export default function BrokerCompanyInfo({
  path,
  actions,
  step,
  onLoad,
  onNext,
  sanitize,
}) {
  const { setFunnelStage, setDataLayer } = actions

  const { applyUtm } = useUtm()
  const { contact } = useContact()
  const { startLoad, finishLoad } = useLoading()
  const history = useHistory()
  const { buildRoute } = useRouteBuilder()
  const { country, countryFullName } = useInternationalization()

  const employeesNumberThreshold = 999

  function handleIdFromContact(data) {
    const { id, ...restData } = data
    return restData
  }

  useEffect(() => {
    if (onLoad) {
      const data = {
        id: contact.id,
        funnelStage: 'company_info',
      }
      onLoad(data)
    }
  }, [])

  useEffect(() => {
    if (contact.id) {
      applyUtm(contact.id)
    }
  }, [contact.id])

  async function handleForm(formValues) {
    let data = mapFormToBroker(
      {
        ...formValues,
        companyName: formValues.company,
        funnelStage: 'company_info',
      },
      countryFullName
    )

    data = sanitize(data)

    data = handleIdFromContact(data)

    if (country === 'uk' && formValues.employeesNumber > 100) {
      data.funnelStage = 'meeting_intent'
      await setFunnelStage(data)
      history.push(buildRoute('thank-you/broker'))
      return
    }

    data = shouldAddBrokerFakeEmail(data, country)

    await setFunnelStage(data)

    if (formValues.employeesNumber > employeesNumberThreshold) {
      if (country === 'br') {
        window.location.href = 'https://gympass.typeform.com/to/fUc0youp'
      } else {
        history.push(buildRoute('thank-you/broker'))
      }
      return
    }

    startLoad()

    setDataLayer(step, path, {
      actorData: {
        email: formValues.email,
        role: formValues.role,
        department: 'Human Resources',
      },
      companyData: {
        employeesNumber: formValues.employeesNumber,
        industry: formValues.industry,
        state: formValues.state,
      },
    })

    finishLoad()

    if (onNext) {
      onNext()
    }
  }

  return (
    <>
      <Sections.Appbar />
      <Sections.Main handleForm={handleForm} />
      <Footer company="Gympass B.V." />
    </>
  )
}

BrokerCompanyInfo.propTypes = {
  path: string.isRequired,
  actions: shape({
    setFunnelStage: func,
    setDataLayer: func,
  }).isRequired,
  step: number.isRequired,
  onLoad: func,
  onNext: func,
  sanitize: func,
}

BrokerCompanyInfo.defaultProps = {
  onLoad: undefined,
  onNext: undefined,
  sanitize: contact => contact,
}
